import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { primaryAffiliationTypes } from '../../step.constants';
import { NgMultiSelectOption } from '../../../shared/interfaces/ng-multi-select-option.interface';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'step-primary-affiliation-multiselect',
  templateUrl: './primary-affiliation-multiselect.component.html',
  styleUrls: ['./primary-affiliation-multiselect.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PrimaryAffiliationMultiselectComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PrimaryAffiliationMultiselectComponent
    }
  ]
})
export class PrimaryAffiliationMultiselectComponent implements OnInit, ControlValueAccessor {
  dropdownSettings = {
    singleSelection: false,
    enableCheckAll: false,
    itemsShowLimit: 8,
    allowSearchFilter: true
  };
  //#endregion

  @Input()
  disabled = false;
  @Output()
  change: EventEmitter<NgMultiSelectOption[]> = new EventEmitter<NgMultiSelectOption[]>();
  @Input()
  selectedValues: string[];
  onChange = (value) => { };
  onTouched = () => { };
  touched = false;

  // Get list of parishes from constants
  affiliations: NgMultiSelectOption[] = primaryAffiliationTypes.map(p => {
    return {
      id: p.name,
      text: p.name
    };
  });

  selectedYears: string[] = [];
  selectedYearObjects: NgMultiSelectOption[] = [];

  constructor() { }

  writeValue(value: any) {
    if (value) {
      this.selectedYears = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  ngOnInit() {
    if (this.selectedValues && this.selectedValues.length > 0) {
      this.selectedYearObjects = this.selectedValues.map(p => {
        return {
          id: p,
          text: p
        };
      });
    }
  }

  onSelectionChange(year: NgMultiSelectOption, event: 'select' | 'deselect') {
    // Handle appropiate selection event to modify the selectedParishes array.
    if (event === 'select') {
      this.selectedYears.push(year.text);
    } else {
      this.selectedYears.splice(this.selectedYears.indexOf(year.text), 1);
    }
    this.onChange(this.selectedYears);
    // Emit new parishes
    this.change.emit(this.selectedYearObjects);
  }
  onSelectAll(selectedYears: NgMultiSelectOption[]) {
    this.selectedYears = selectedYears.map(sy => sy.text);
    this.selectedYearObjects.splice(0);
    this.selectedYearObjects.push(...selectedYears);

    // Emit new parishes
    this.change.emit(this.selectedYearObjects);
  }

  parseSelectedParishes(selectedYears: string[]) {
    // Parse Parishes to comply with ng-multiselect ngModel
    if (selectedYears && selectedYears.length > 0) {
      this.selectedYearObjects = selectedYears.map(p => {
        return {
          id: p,
          text: p
        };
      });
    } else {
      this.selectedYearObjects = [];
    }

    if (selectedYears) {
      this.selectedYears = selectedYears;
    } else {
      this.selectedYears = [];
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const type = control.value;
    if (type && type.length < 1) {
      return {
        mustBeAtLeastOne: {
          type
        }
      };
    }
  }
}
